import React, { useState, useEffect } from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useSelector } from 'react-redux'
import { getPrevLocation } from '../selectors/openForWork.selector'

function ExpandablePanel({
  title,
  renderBody,
  defaultExpanded = false,
  isSearchAssignment,
  setIsSearchAssignment,
  pageLocation,
  isSearchEmployer,
  setIsSearchEmployer,
  isSearchApplication,
  setIsSearchApplication,
  isSearchWorkshift,
  setIsSearchWorkshift,
  isSeeMyApplication,
  isAddExtraPaddingEnd = false,
  paddingEnd = 0,
  employerSide
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const prevLocation = useSelector(getPrevLocation)

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev)

    if (pageLocation === 'open_for_work_assignments') {
      setIsSearchAssignment?.(false)
    }
    if (pageLocation === 'open_for_work_workshifts') {
      setIsSearchEmployer?.(false)
      setIsSearchWorkshift?.(false)
    }
    if (pageLocation === 'open_for_work_applications') {
      setIsSearchApplication?.(false)
    }
  }

  useEffect(() => {
    if (
      isSearchAssignment ||
      isSearchEmployer ||
      isSearchApplication ||
      isSearchWorkshift ||
      (isSeeMyApplication &&
        prevLocation === '/dashboard/openforwork/assignments')
    ) {
      setIsExpanded(true)
    }
  }, [
    isSearchAssignment,
    isSearchEmployer,
    isSearchApplication,
    isSearchWorkshift,
    isSeeMyApplication,
    prevLocation
  ])

  return (
    <div>
      <div className="panel panel-default" style={{background: employerSide && 'none'}}>
        <div
          onClick={toggleExpand}
          className="panel-heading"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          <div style={{ flex: 1, textAlign: 'center' }}>
            <h3
              className="panel-title"
              style={{ margin: 0, textTransform: 'none', fontWeight: '500' }}
            >
              {title}
            </h3>
          </div>
          <KeyboardArrowDownIcon fontSize="large" />
        </div>
        {isExpanded && <div className="panel-body pd-0">{renderBody()}</div>}
      </div>
      {/*KAS-806 Add div with padding to prevent blank below footer compoment when content of page is short*/}
      {isAddExtraPaddingEnd && !isExpanded ? (
        <div style={{ padding: paddingEnd }}></div>
      ) : null}
    </div>
  )
}

export default ExpandablePanel
